import { FileHelpers } from "../helpers/File.helpers";

export const useDownloadFileEnh = ({
  apiDefinition,
  preDownload,
  postDownload,
  onError
}) => {
  const download = async () => {
    try {
      preDownload();
      const response = await apiDefinition();
      const filename = FileHelpers.getFilenameFromAxiosResponse(response);
      const href = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      postDownload();
    } catch (error) {
      onError();
    }
  };

  return { download };
};
